import { createContext, useEffect, useReducer } from 'react';
import PropTypes from 'prop-types';
import { paramCase } from 'change-case';
import axios from '../utils/axios';
import { isValidToken, setSession } from '../utils/jwt';
import { PATH_AUTH } from '../routes/paths';

const initialState = {
  isAuthenticated: false,
  isInitialized: false,
  user: null,
};

const handlers = {
  INITIALIZE: (state, action) => {
    const { isAuthenticated, user } = action.payload;
    return {
      ...state,
      isAuthenticated,
      isInitialized: true,
      user,
    };
  },
  LOGIN: (state, action) => {
    const { user } = action.payload;
    return {
      ...state,
      isAuthenticated: true,
      user,
    };
  },

  LOGINONE: (state, action) => {
    const { user } = action.payload;
    return {
      ...state,
      isAuthenticated: true,
      user,
    };
  },

  LOGOUT: (state) => ({
    ...state,
    isAuthenticated: false,
    user: null,
  }),
  REGISTER: (state, action) => {
    const { user } = action.payload;
    return {
      ...state,
      user,
    };
  },
};

const reducer = (state, action) => (handlers[action.type] ? handlers[action.type](state, action) : state);

const AuthContext = createContext({
  ...initialState,
  method: 'jwt',
  login: () => Promise.resolve(),
  loginone: () => Promise.resolve(),
  logout: () => Promise.resolve(),
  register: () => Promise.resolve(),
});

AuthProvider.propTypes = {
  children: PropTypes.node,
};

function AuthProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    const initialize = async () => {
      try {
        const accessToken = window.localStorage.getItem('accessToken');
        if (accessToken && isValidToken(accessToken)) {
          setSession(accessToken);
          dispatch({
            type: 'INITIALIZE',
            payload: {
              isAuthenticated: true,
              // user,
            },
          });
        } else {
          dispatch({
            type: 'INITIALIZE',
            payload: {
              isAuthenticated: false,
              user: null,
            },
          });
        }
      } catch (err) {
        console.error(err);
        dispatch({
          type: 'INITIALIZE',
          payload: {
            user: null,
          },
        });
      }
    };

    initialize();
  }, []);

  const login = async (email, password, rememberMe) => {
    localStorage.setItem('remembermeone', rememberMe);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/web_register/login`,
        {
          email,
          password,
        },
        {
          headers: {
            Authorization: `Bearer`,
          },
        }
      );
      const { user } = response.data;

      const email_popup = window.localStorage.setItem('email_popup', user.email);
      const password_popup = window.localStorage.setItem('new_password', user.password);
      const userid = window.localStorage.setItem('user_id', response?.data?.user?.user_id);
      const userType = window.localStorage.setItem('user_type', user?.user_type);
      const accessToken = window.localStorage.setItem('accessToken', response?.data?.access.token);
      dispatch({
        type: 'LOGIN',
        payload: {
          user,
        },
      });
      return { success: true, message: 'Login Sucess' };
    } catch (error) {
      return { success: false, message: error };
    }
  };
  const loginone = async (email, password, radio) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/web_register/login`,
        {
          email,
          password,
        },
        {
          headers: {
            Authorization: `Bearer`,
          },
        }
      );
      const { user } = response.data;
      const userid = window.localStorage.setItem('user_id', response?.data?.user?.user_id);
      const userType = window.localStorage.setItem('user_type', [...user?.user_type, radio]);
      const accessToken = window.localStorage.setItem('accessToken', response?.data?.access.token);

      dispatch({
        type: 'LOGINONE',
        payload: {
          user,
        },
      });
      return {
        success: true,
        message: 'Login Sucess',
        status: 200,
        userType: response?.data?.user?.user_type,
        accessToken: response?.data?.access.token,
      };
    } catch (error) {
      return { success: false, message: error };
    }
  };

  const register = async (fname, lname, email, password, confirmpassword, mobileno, usertype) => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/web_register/user_register`, {
        fname,
        lname,
        email,
        password,
        confirm_password: confirmpassword,
        mobileno,
        user_type: usertype,
      });
      const { user } = response.data;
      const userId = response.data.user.user.id;
      const user_type = response.data.user.user.user_type;

      if (response.status === 200) {
        console.log(`${PATH_AUTH.verify}/${paramCase(userId.toString())}`);
      }
      if (response.error) {
        console.log(response.error);
      }

      dispatch({
        type: 'REGISTER',
        payload: {
          user,
        },
      });

      return {
        success: true,
        message: '',
        userId: response.data.user.user.id,
        mobileno: response.data.user.user.mobileno,
        userType: response.data.user.user.user_type,
      };
    } catch (error) {
      return { success: false, message: error };
    }
  };

  const logout = async () => {
    setSession(null);
    localStorage.removeItem('user_type');
    localStorage.removeItem('user_id');
    const remmmberss = localStorage.getItem('remembermeone');
    const ee = localStorage.getItem('email_popup');
    const passs = localStorage.getItem('new_password');
    if (remmmberss === 'true') {
      localStorage.getItem('remembermeone');
      localStorage.getItem('email_popup');
      localStorage.getItem('new_password');
    } else {
      localStorage.removeItem('email_popup');
      localStorage.removeItem('new_password');
    }
    dispatch({ type: 'LOGOUT' });
  };

  return (
    <AuthContext.Provider
      value={{
        ...state,
        method: 'jwt',
        login,
        loginone,
        logout,
        register,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export { AuthContext, AuthProvider };
